import {lazy} from './lang.js';

export const patternSwitch = (patternNumber, sequencerEngine, track) => {
    sequencerEngine.switchToPattern(
        Math.round(lazy(patternNumber)),
        true,
        track.subSequence,
        undefined,
        undefined,
        true);
};
